module.exports = __webpack_public_path__ + "img/psoui.7d55c9ab.png";